import {
  HttpErrorResponse,
  HttpEvent,
  HttpHandler,
  HttpInterceptor,
  HttpRequest,
  HttpResponse
} from '@angular/common/http';
import {Observable, throwError} from 'rxjs';
import {environment} from "../../environments/environment";
import {catchError, map} from "rxjs/operators";
import {Injectable} from "@angular/core";
import {NotificationService} from "../services/notification.service";
import {AuthService} from "../services/auth.service";
import {StorageService} from "../services/storage.service";


@Injectable()
export class AuthInterceptor implements HttpInterceptor {

  constructor(
    private notificationService: NotificationService,
    private auth: AuthService,
    private storageService: StorageService
  ) {
  }

  intercept(request: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const currentClient = this.storageService.get('currentClient');
    const currentLanguage = localStorage.getItem('lang') || 'sw';
    const modifiedHeaders = (currentClient && request?.headers?.has('Authorization') === false) ?
      {Authorization: `Bearer ${currentClient}`} : {};

    request = request.clone({
      setHeaders: {
        ...modifiedHeaders,
        'Content-Language': currentLanguage,
      }
    });

    return next.handle(request).pipe(
      map((event: HttpEvent<any>) => {
        if (event instanceof HttpResponse) {

        }
        return event;
      }),
      catchError((error: HttpErrorResponse) => {

        if (request.url === environment.SERVER_URL + '/o/token/') {
          if (error.status === 400 && error?.error?.error === 'invalid_grant') {
            this.notificationService.errorMessage('Invalid username or password');
          } else if (error.status === 423) {
            this.notificationService.errorMessage('Your account is locked due to incorrect multiple login attempts,' +
              ' kindly contact ICT support team');
          }
        }

        const data = {
          reason: error?.statusText,
          status: error.status,
          causedBy: error.message
        };
        this.auth.collectFailedRequest(data);
        return throwError(() => new Error('Error: ' + error.message));
      }));
  }
}
